import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { delay } from 'rxjs/operators';
import { inOut, slowInOut, translate } from '../../animations/animations';
import { AuthenticationService } from '../../../../services/authentication.service';
import { LoginUser } from '../../entities/login-user';

/**
 * Login component
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [inOut, translate, slowInOut],
})
export class LoginComponent implements OnInit {
  /**
   * Login form
   */
  loginForm: FormGroup;

  /**
   * Check if form is submitted
   */
  submitted: boolean;

  /**
   * Is user logged
   */
  userLogged: boolean;

  /**
   * User
   */
  user: LoginUser;

  /**
   * Constructor
   *
   * @param authService AuthenticationService
   * @param router Router
   */
  constructor(private authService: AuthenticationService, private router: Router) {
    this.submitted = false;
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.loginForm = new FormGroup({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
  }

  /**
   * onSubmit
   *
   * @param $event Event
   */
  onSubmit($event: Event): void {
    $event.preventDefault();
    if (this.loginForm.valid) {
      this.submitted = true;
      this.authService
        .login(this.loginForm.value)
        .pipe(delay(2000))
        .subscribe(
          (data) => {
            this.userLogged = true;
            this.submitted = false;
            this.user = LoginUser.createFromJson(data.user);

            this.sleep(2000).then(() => {
              this.router.navigateByUrl('/');
            });
          },
          (error) => {
            this.submitted = false;
          }
        );
    }
  }

  /**
   * Sleep function
   *
   * @param milliseconds number
   *
   * @returns Promise with timeout
   */
  sleep(milliseconds): Promise<boolean> {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  /**
   * Active animation
   *
   * @param bool Boolean
   *
   * @returns String with animation status
   */
  activeAnimation(bool: boolean): string {
    return bool ? 'active' : 'inactive';
  }
}
